import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import toast from "react-hot-toast";
import messages from "../../assets/Local/Local";

const initialState = {
    geminiSalaryGradeData: [],
    jobDescription: null,
    // singleBidding: null,
    // totalRecords: 0,
};

export const geminiSalaryGrade = createAsyncThunk(
    "aiTools/geminiSalaryGrade",
    async (values, { dispatch }) => {
        return await axiosInstance
            .post(`gemini/search-salary-grades`, values)
            .then((response) => {
                toast.success(messages[localStorage.getItem("lang")].shared.done);
                return response;
            })
            .catch((error) => {
                return error;
            });
    }
);
export const geminiJobDescription = createAsyncThunk(
    "aiTools/geminiJobDescription",
    async (values, { dispatch }) => {
        return await axiosInstance
            .post(`/gemini/search-job-description`, values)
            .then((response) => {
                // toast.success(messages[localStorage.getItem("lang")].shared.done);
                return response;
            })
            .catch((error) => {
                return error;
            });
    }
);

const AiToolsSlice = createSlice({
    name: "aiTools",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(geminiJobDescription.fulfilled, (state, action) => {
            state.jobDescription = action.payload.data;
        });
        builder.addCase(geminiSalaryGrade.fulfilled, (state, action) => {
            state.geminiSalaryGradeData = action.payload.data;
        });
    },
});
export const AiToolsReducer = AiToolsSlice.reducer;
